import styled from "@emotion/styled";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { i18n, ProductTypeCodeEnum, setPaymentType, useAppDispatch } from "src/common";
import { useSendGeneralTransferDetailsMutation } from "src/common/api/apollo/additional/types/types";
import { Button, Card, Divider, Flex, Text } from 'src/components';
import { AppRoutesAdditional } from "src/pages/app";
import { colors } from "src/theme";

const FlexStyle = styled(Flex)({
  padding: '0 12px',
});

interface GeneralTranferPaymentInfoCardAdditionalProps {
  type?: string;
  offerId: string;
}

export const GeneralTranferPaymentInfoCardAdditional = ({ type = 'oneTime', offerId }: GeneralTranferPaymentInfoCardAdditionalProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [sendGeneralTransferDetails] = useSendGeneralTransferDetailsMutation();

  useEffect(() => {
    dispatch(setPaymentType(type));
  }, [type]);

  const handlePay = () => {
    if (type === 'oneTime') {
      sendGeneralTransferDetails({
        variables: { id: offerId, input: { installments: 1, type: ProductTypeCodeEnum.DODATNO } }
      });
      navigate(`${AppRoutesAdditional.CHECKOUT_PAYMENT_SENT.fullPath}/${offerId}`)
    }
    else {
      sendGeneralTransferDetails({
        variables: { id: offerId, input: { installments: 12, type: ProductTypeCodeEnum.DODATNO } }
      });
      navigate(`${AppRoutesAdditional.CHECKOUT_PAYMENT_SENT_INSTALLMENTS.fullPath}/${offerId}`)
    }
  }

  return (
    <Flex vertical gap={16}>
      <Card background={colors.success2} radius={8} padding={'4px 8px'}>
        <Flex gap={8} align='flex-start' vertical>
          <Text type='base' bold color={colors.text1}>{i18n.t('components.cards.generalTranferPaymentInfoCard.important')}</Text>
          <Text type='small' color={colors.text1}>{i18n.t('components.cards.generalTranferPaymentInfoCard.text')} <b>{i18n.t('components.cards.generalTranferPaymentInfoCard.text2')}</b> {i18n.t('components.cards.generalTranferPaymentInfoCard.text3')}</Text>
        </Flex>
      </Card>
      <Divider dashed color={colors.border3} />
      <FlexStyle gap={12} vertical>
        <Text type='base' bold color={colors.text1}>{i18n.t('components.cards.generalTranferPaymentInfoCard.steps')}</Text>
        <Flex gap={8} align='flex-start' vertical>
          {[
            i18n.t('components.cards.generalTranferPaymentInfoCard.step1'),
            i18n.t('components.cards.generalTranferPaymentInfoCard.step2'),
            i18n.t('components.cards.generalTranferPaymentInfoCard.step3'),
            i18n.t('components.cards.generalTranferPaymentInfoCard.step4')
          ].map((step, index) => (
            <Flex key={index} gap={8} align="flex-start">
              <Text type='small' color={colors.text1} style={{ minWidth: '20px' }}>
                {index + 1}.
              </Text>
              <Text type='small' color={colors.text1}>
                {step}
              </Text>
            </Flex>
          ))}
        </Flex>
        {type === 'installments' && <Text type='small' color={colors.text1}>{i18n.t('components.cards.generalTranferPaymentInfoCard.text4')}</Text>}
      </FlexStyle>
      <Button btnType='primary' text={i18n.t('components.cards.generalTranferPaymentInfoCard.button')} onClick={handlePay} />
    </Flex>
  )
}
